import {action} from "typesafe-actions";
import {ActionsTypes, AlertType} from "./types";

export const addAlert = (alert: AlertType) => action(ActionsTypes.ADD_ALERT, alert);

export const removeAlert = (id: number) => action(ActionsTypes.REMOVE_ALERT, id);

export const clearAlerts = () => action(ActionsTypes.CLEAR_ALERTS);